import React from 'react';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const CommonSnackbar = ({ message, status = 'info', open, setOpen }) => {
  // Close the Snackbar after the autoHideDuration or when the user clicks the close button
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return; // Prevent closing when clicking outside
    setOpen(false); // Close the Snackbar
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} // Positioning
    >
      <Alert
        onClose={handleClose}
        severity={status}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default CommonSnackbar;
